import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { store as mainStore } from '../App';
import History, { toParentPath } from 'helpers/History';
import { t, T } from 'helpers/i18n';
import { Validation } from 'helpers/Validation';
import { mapValues, objectValues } from 'helpers/Utils';
import { Button, Field, FieldType } from 'elements';
class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: {}
        };
        this.handleChange = (name, value, column) => {
            // console.log('handleChange: ', `name: ${name} value: ${value} column: ${column}`)
            this.setState({ values: Object.assign(Object.assign({}, this.state.values), { [column ? column : name]: value }) }, () => {
                // console.log('handleChange: state.value', this.state.values)
            });
        };
        this.handleCancel = () => {
            // console.log('handleCancel')
            const { onCancel } = this.props;
            if (onCancel)
                return onCancel();
            toParentPath();
        };
        this.handleDisable = (disable) => () => {
            // console.log('handleDisable')
            const { values, store, onDisable } = this.props;
            const accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (onDisable)
                    return onDisable(disable);
                if (store && store.disable && values) {
                    store.disable(values.id, disable).then(toParentPath);
                }
            }
        };
        this.handleDelete = () => {
            console.log('handleDelete');
            const { values, store, onDelete } = this.props;
            const accept = confirm(t('confirmDelete'));
            if (accept) {
                if (onDelete)
                    return onDelete();
                if (store && store.delete && values) {
                    store.delete(values.id).then(toParentPath);
                }
            }
        };
        this.handleReset = () => {
            console.log('handleReset');
            this.setState({ values: this.parsedValues() });
        };
        this.handleSubmit = () => {
            // console.log('handleSubmit')
            const { fields, values: propsValues, store, onSubmit } = this.props;
            let values = Object.assign({}, this.state.values);
            // console.log('handleSubmit - fields', fields)
            // console.log('handleSubmit - values', values)
            // console.log('handleSubmit - schema', this.schema)
            // console.log('handleSubmit - propsValues', propsValues)
            const validation = new Validation(values, this.schema);
            if (validation.valid) {
                // Remove unmodified value
                // console.log('antes de fields.map - values', values)
                this.fields.map(field => {
                    if (propsValues && values[field.column ? field.column : field.name] === propsValues[field.column ? field.column : field.name]) {
                        delete values[field.column ? field.column : field.name];
                    }
                });
                if (Object.keys(values).length === 0)
                    return mainStore.UI.newWarning(T('nothingModified'));
                // Convert empty strings to null
                // console.log('antes de mapValues - values', values)
                values = mapValues(values, value => (value === '' ? null : value));
                // console.log('mapValues - values', values)
                // Use FormData instead of JSON if there is a image in value
                let data;
                if (Object.keys(this.schema).includes('image')) {
                    // console.log('handleSubmit - image')
                    data = new FormData();
                    Object.keys(values).forEach(key => {
                        if (values[key])
                            data.append(key, values[key]);
                    });
                }
                else {
                    data = values;
                }
                // console.log('handleSubmit - data', data)
                if (onSubmit)
                    return onSubmit(data);
                if (store && data) {
                    let request;
                    if (propsValues) {
                        request = store.update(propsValues.id, data);
                    }
                    else {
                        request = store.create(data);
                    }
                    request.then(toParentPath);
                }
                else {
                    mainStore.UI.newWarning('error indefinido');
                }
            }
            else {
                mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
                console.log('handleSubmit - !validation.valid - validation.errors', validation.errors);
            }
        };
        this.fields = props.fields.filter(field => field);
        this.schema = this.fields.reduce((previous, { name, rules, column }) => {
            /*console.log('name', name)
            console.log('column', column)
            console.log('rules', rules)*/
            previous[column ? column : name] = rules;
            return previous;
        }, {});
        /*this.state = {
          value: this.parsedValues()
        }*/
    }
    componentWillMount() {
        this.setState({ values: this.parsedValues() });
    }
    render() {
        const { fields, delete: canBeDeleted, loading } = this.props;
        const { values } = this.state;
        const canBeDisabled = 'disabled' in (this.props.values || {});
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        return (React.createElement(Wrapper, null,
            this.fields.map(field => (React.createElement(Field, { key: field.column ? field.column : field.name, field: Object.assign(Object.assign({}, field), { value: values[field.column ? field.column : field.name] || '' }), onChange: this.handleChange }))),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('cancel'))),
                this.props.values && canBeDisabled ? (this.props.values.disabled ? (React.createElement(StyledButton, { onClick: this.handleDisable(false) }, t('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, t('disable')))) : canBeDeleted ? (React.createElement(StyledButton, { onClick: this.handleDelete }, t('delete'))) : null,
                React.createElement(StyledButton, { onClick: this.handleReset }, t('reset')),
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    }
    parsedValues(props = this.props) {
        const values = props.values || {};
        console.log('parsedValues - values', values);
        const result = this.fields.reduce((fields, field) => {
            // console.log('field.column', field.column)
            const indice = field.column ? field.column : field.name;
            // console.log('indice', indice)
            // console.log('values[indice]', values[indice])
            return Object.assign(Object.assign({}, fields), { [indice]: values[indice]
                    ||
                        (field.type === FieldType.Select
                            ? (field.placeholder
                                ? null
                                : field.options && field.options[0] && field.options[0].value)
                            : field.type === FieldType.Date ? new Date() : values[indice]) });
        }, {});
        console.log('parsedValues - result', result);
        return result;
    }
}
export default Form;
const Wrapper = cxs('div')({
    paddingBottom: Theme.size.bar,
    [mediaQueries.desktop]: {
        display: 'flex',
        flexWrap: 'wrap',
        paddingBottom: 0
    }
});
const ButtonsBar = cxs('div')({
    display: 'flex',
    width: '100%',
    position: 'absolute',
    bottom: 0,
    backgroundColor: Theme.color.background,
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    '> button': {
        flex: 'auto',
        borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
        ':last-child': {
            borderWidth: 0
        }
    },
    [mediaQueries.desktop]: {
        position: 'initial',
        marginTop: Theme.size.space[2],
        borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    }
});
const StyledButton = cxs(Button)({
    [mediaQueries.desktop]: {
        padding: Theme.size.space[2]
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Form.tsx
// module id = 479
// module chunks = 0